import { cn } from "@/utils";
import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
  loading?: boolean;
}

export default function Button({
  variant = "primary",
  loading,
  className,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const variants = {
    primary:
      "bg-[var(--tenant-accent-color)] text-white hover:bg-[var(--tenant-accent-color-darker)]",
    secondary:
      "bg-checkout-fill text-checkout-fg hover:bg-checkout-fill-strong border border-checkout-hairline",
    ghost: "bg-transparent text-checkout-muted hover:text-checkout-fg hover:bg-checkout-fill",
  };

  return (
    <button
      className={cn(
        "group inline-flex h-12 items-center justify-center gap-2 rounded-full px-6 text-sm font-semibold transition-all duration-500 ease-soft active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="h-4 w-4 rounded-full border-2 border-white/30 border-t-white animate-spin" />
      ) : (
        children
      )}
    </button>
  );
}
